/*
  Подсказка у выключенной кнопки, пока идёт перенос в портфель (01.10.2026,
  проверка перед выкладкой).

  Пока перенос идёт, сервер отказывает выбору в споре, решению по
  расхождениям, сверке страницы и удалению файла (409): они меняют те же
  сведения, которые перенос сейчас пишет. Кнопки выключаются заранее, а эта
  строка объясняет почему - выключенная кнопка без слов выглядит поломкой.
  Одна на четыре места, чтобы формулировка не разъехалась.
*/

export const LOCK_TITLE = 'Идёт перенос в портфель'

export default function TransferLock({ locked }) {
  if (!locked) return null
  return (
    <p className="muted" role="status">
      {LOCK_TITLE} - кнопки станут доступны, когда он закончится.
    </p>
  )
}
